import { Component, OnDestroy } from '@angular/core';
import { Observable} from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { UserService } from './Services/User/user.service';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';

import { ConnectionService } from 'ng-connection-service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ToasterService } from './Services/toastr/toaster.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnDestroy {
  title = 'Able Trace';
  showFiller = false;
  status: any;
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches)
    );
  activeTab = 'admin'

  constructor(private breakpointObserver: BreakpointObserver,
    private router: Router,
    private userService: UserService,
    private httpClient: HttpClient,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private connectionService: ConnectionService,
    private toasterService: ToasterService
  ) { }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 8000,
    });
  }

  ngOnInit() {
    this.connectionService.monitor().subscribe(isConnected => {
      if (!isConnected) {
        this.status = "Check Internet Connection";
        // alert(this.status)
        this.openSnackBar(this.status, "try again")

      }
    })

    if (!!this.userService.getUserdetails()) {
      if (!!this.userService.getUserdetails().super_admin) {
        this.router.navigate(["SuperAdminHome"], { replaceUrl: true });
      }
      else if (!!this.userService.getUserdetails().CompanyUser) {
        if (this.userService.getUserdetails().first_time_login == true) {
          // this.gotoForgotPswd()
          this.router.navigate(["/login"]);
        } else {
          // if (this.userService.getUserdetails().terms_condition == true)
          //   this.router.navigate(["AdminHome"], { replaceUrl: true });
          // else
          //   this.router.navigate(["/terms"], { replaceUrl: true });
          if (!this.userService.getUserdetails().terms_condition)
            this.router.navigate(["/terms"], { replaceUrl: true });
        }
      }
    }
    else {
      // this.router.navigate(["/login"]);
    }



  }

  ngOnDestroy(): void {
    this.toasterService.cleanup();
  }
}




